module.exports = __webpack_public_path__ + "static/img/intro-thumb-1.76bad42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newImg/intro-thumb-1.png
// module id = 0c2N
// module chunks = 0